import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout sin metadatos (evita canonical duplicado en las páginas hoja). */
export const Route = createFileRoute("/en/answers")({
  component: () => <Outlet />,
});
